var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{staticClass:"organization-menu",attrs:{"items":_vm.auth.organizations,"item-text":"name","item-value":"id","solo":"","dense":"","hide-details":"","dark":false},model:{value:(_vm.organizationId),callback:function ($$v) {_vm.organizationId=$$v},expression:"organizationId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }